import { Alert, MenuItem, Stack, TextField, Typography } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useParams } from "react-router-dom";

import { api } from "../api/client";
import { LoadingState } from "../components";
import { formatDate } from "../i18n/format";
import { Markdown } from "../marketing/Markdown";
import { Section, Seo } from "../marketing/MarketingLayout";

type Legal = { kind: string; version: string; title: string; body_markdown: string; effective_at: string; versions: { version: string; effective_at: string }[] };

export function LegalPage({ kind: kindProp }: { kind?: string }) {
  const params = useParams();
  const kind = kindProp ?? params.kind ?? "terms";
  const [version, setVersion] = useState<string | undefined>(undefined);
  const doc = useQuery({
    queryKey: ["legal", kind, version],
    queryFn: async () => (await api.GET("/api/v1/website/legal/{kind}/", { params: { path: { kind }, query: version ? { version } : {} } })).data as unknown as Legal | undefined,
  });
  return (
    <Section>
      <Seo title={doc.data?.title ?? "Legal"} />
      {doc.isLoading && <LoadingState />}
      {doc.isError || (!doc.isLoading && !doc.data) ? <Alert severity="warning">This document is not available yet.</Alert> : null}
      {doc.data && (
        <>
          <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
            <Typography variant="caption" color="text.secondary">Version {doc.data.version} · effective {formatDate(doc.data.effective_at)}</Typography>
            {doc.data.versions.length > 1 && (
              <TextField select size="small" label="Version" value={version ?? doc.data.version} onChange={(e) => setVersion(e.target.value)} sx={{ width: 160 }}>
                {doc.data.versions.map((v) => <MenuItem key={v.version} value={v.version}>{v.version}</MenuItem>)}
              </TextField>
            )}
          </Stack>
          <Markdown source={doc.data.body_markdown} />
        </>
      )}
    </Section>
  );
}
